import type { Dict } from './en'

export const uk: Dict = {
  lang: { en: 'English', uk: 'Українська', ru: 'Русский', label: 'Мова' },

  nav: {
    overview: 'Огляд',
    posting: 'Постинг',
    settings: 'Налаштування',
    dashboard: 'Дашборд',
    phones: 'Телефони',
    workspace: 'Робочий простір',
    videos: 'Відео',
    distributions: 'Розсилки',
    posts: 'Пости',
    sources: 'Джерела',
    scenarios: 'Сценарії',
    machines: 'Машини',
    accounts: 'Акаунти',
    directions: 'Напрями',
    publications: 'Публікації',
    links: 'Посилання',
    users: 'Користувачі',
    myClaude: 'Мій Claude',
    signOut: 'Вийти',
    serviceToken: 'сервісний токен',
    signedInAs: (email) => `Ви увійшли як ${email}`,
    withToken: 'Вхід за сервісним токеном',
    lightTheme: 'Світла тема',
    darkTheme: 'Темна тема',
    groupWork: 'Робота',
    groupSetup: 'Налаштування',
    collapse: 'Згорнути меню',
    expand: 'Розгорнути меню',
  },

  auth: {
    title: 'Ferma Hub',
    intro: 'Увійдіть робочим акаунтом, щоб дістатися машин і телефонів на них.',
    email: 'Робоча пошта',
    password: 'Пароль',
    signIn: 'Увійти',
    signingIn: 'Вхід…',
    refused: 'Таку пошту й пароль не прийнято.',
    notConfigured: 'На сервісі ще не налаштовано вхід — зверніться до адміністратора.',
    failed: (msg) => `не вдалося увійти: ${msg}`,
    corporateOnly: 'Лише корпоративні акаунти (@mornhouse.com). Парольні акаунти створює адміністратор.',
    googleRefused: 'Google не підтвердив цей вхід. Спробуйте ще раз.',
    googleWrongDomain: 'Увійдіть корпоративним акаунтом Google (@mornhouse.com).',
    usePassword: 'Увійти за паролем',
  },

  devices: {
    notRecommended: (n: number) => `${n} пост. поза рекомендаціями`,
    title: 'Телефони',
    onlineOf: (online, total) => `${online} з ${total} доступні`,
    search: 'Модель, серійник, машина, акаунт…',
    all: 'усі',
    free: 'вільні',
    mine: 'мої',
    refresh: 'Оновити',
    nothing: 'Нічого не знайдено.',
    hint: 'Телефон з’являється тут сам, щойно його під’єднали до машини — реєструвати нічого не треба.',
    open: 'відкрити →',
    mySession: 'ваша сесія',
    busyFor: (min) => `зайнятий ${min} хв`,
    busy: 'зайнятий',
    offline: 'офлайн',
    error: (msg) => `помилка: ${msg}`,
    statusOnline: 'Онлайн — можна підключатися',
    statusBusy: 'Зайнятий — його тримає хтось інший',
    posting: 'публікація',
    statusPosting: 'Телефон тримає автоматична публікація; відібрати його не можна',
    statusOffline: 'Офлайн — перевірте кабель і машину',
    adbTrouble: (state) => `adb: ${state}`,
    battery: (pct) => `${pct}%`,
    hot: (deg) => `${deg}°`,
    machineFilter: 'Машина',
    allMachines: 'усі машини',
    directionFilter: 'Напрям',
    allDirections: 'усі напрями',
    noDirection: 'без напряму',
    noAccount: 'акаунт TikTok не вказано',
  },

  serviceKeys: {
    title: 'Ключі для інших сервісів',
    sub: 'Ключ лише на читання для іншого нашого сервісу, наприклад обліку обладнання. Він читає і нічого не змінює.',
    name: 'Хто ним користуватиметься',
    namePh: 'Облік обладнання',
    scopes: 'Що можна читати',
    create: 'Випустити ключ',
    shownOnce: 'Ключ показується один раз — скопіюйте його, перш ніж піти зі сторінки.',
    issued: 'Ключ — видно лише зараз',
    list: 'Випущені ключі',
    listSub: 'Відкличте ключ, і сервісу з ним відмовлять з наступного ж запиту.',
    none: 'Ключів ще не випускали.',
    by: (email: string) => `випустив ${email}`,
    used: (at: string) => `востаннє ${at}`,
    neverUsed: 'ще не використовувався',
    revoke: 'Відкликати',
    remove: 'Видалити',
    live: 'діє',
    revoked: 'відкликано',
    copy: 'копіювати',
    confirmRevoke: 'Відкликати ключ? Сервісу з ним відмовлять з наступного запиту.',
    confirmRemove: 'Видалити ключ? Його теж буде відкликано, і він більше ніколи не спрацює.',
    scope: {
      'read:hubs': 'компи — які підключені і які телефони на кожному',
      'read:devices': 'телефони — модель, статус, комп, акаунт TikTok, хто тримає',
    } as Record<string, string>,
  },
  myClaude: {
    title: 'Підключіть свого Claude',
    sub: 'Ваш Claude працює тут від вашого імені: бачить машини й телефони, бере телефон на ваше ім’я та керує ним, завантажує відео та вихідні матеріали, створює й запускає пости та розсилки. Сценарії, телефони, машини, користувачі та чужий контент лишаються за вами в робочому місці.',
    connectTitle: 'Підключення — без копіювання ключа',
    connectSteps: [
      'У claude.ai, Claude Desktop або Claude Code додайте конектор з адресою нижче — без ключа і без заголовка.',
      'Натисніть Connect. Відкриється сторінка Ferma Hub: перевірте, що там Claude, і натисніть «Дозволити».',
      'Готово — ваш Claude працює від вашого імені, а його ключ з’явиться в списку нижче як будь-який інший.',
    ],
    connectNote: 'Claude Code: виконайте команду нижче один раз, потім наберіть /mcp, виберіть ferma-hub і Authenticate — браузер відкриє ту саму сторінку «Дозволити».',
    manualTitle: 'Ключ вручну — лише для скриптів',
    manualSub: 'Ключ діє від вашого імені так само, як конектор. Краще Connect: нічого копіювати, а відключення — один клік.',
    create: 'Випустити ключ',
    shownOnce: 'Ключ показується один раз — скопіюйте його, перш ніж піти зі сторінки.',
    issued: 'Ваш ключ — видно лише зараз',
    web: 'Claude у браузері з ключем: Settings → Connectors → Add custom connector, URL вище, заголовок Authorization = Bearer <ваш ключ>.',
    code: 'Claude Code з ключем:',
    mine: 'Мої ключі та підключення',
    mineSub: 'Кожен підключений Claude — рядок тут. Відкличте ключ, і цей Claude одразу перестане працювати.',
    none: 'Поки нічого не підключено.',
    revoke: 'Відкликати',
    remove: 'Видалити',
    live: 'діє',
    revoked: 'відкликано',
    copy: 'копіювати',
    confirmRevoke: 'Відкликати ключ? Ваш Claude перестане працювати з ним протягом хвилини.',
    confirmRemove: 'Видалити ключ? Його теж буде відкликано, і він більше ніколи не спрацює.',
  },
  session: {
    openElsewhere: 'Цей телефон уже відкритий в іншій твоїй вкладці.',
    showHere: 'Показати тут',
    holdWarning: (s: number) => `Давно нічого не робилось — телефон звільниться за ${s} с.`,
    keep: 'Лишити телефон',
    holdLeft: (min: number) => `ваш ще ${min} хв без дій`,
    holdLeftTitle: 'Телефон звільняється після 10 хвилин без жодного тапу, клавіші чи встановлення від вас — будь-яка дія скидає лічильник',
    actions: 'Дії з телефоном',
    lapsed: 'Телефон міг звільнитися через неактивність.',
    record: 'Записати сценарій',
    recording: 'Триває запис… стоп',
    recordHint: 'Запис: пройдіть увесь шлях публікації в TikTok зараз. Відтворення почнеться з того екрана, на якому ви зараз (домашній або відкритий додаток). Дотики трохи повільніші — хаб читає екран перед кожним.',
    recordStopped: (n) => `записано кроків: ${n}`,
    recordEmpty: 'нічого не записано',
    recordSaveTitle: 'Зберегти записаний сценарій',
    recordName: 'Назва сценарію',
    recordTextWarning: 'У записі є введення тексту. Його надрукують один в один на кожному телефоні — приберіть крок із підписом, якщо це не потрібно.',
    recordDiscard: 'Відкинути',
    expiredTitle: 'Ваша сесія завершилася',
    expiredBody: 'Сесії навмисно короткі. Поки ви не увійдете знову, тут нічого не працює — натисніть OK, щоб перейти до входу.',
    expiredOk: 'OK',
    pickTitle: 'Оберіть телефон зліва',
    pickBody:
      'Тут відкриється живий екран: тап, свайп зі справжньою швидкістю, утримання, апаратні клавіші, набір з вашої клавіатури, звук, скріншоти — і лог телефона. Саме тут надіслане відео публікують у TikTok вручну.',
    pickNote: 'Один телефон тримає одна людина: у нього один екран, один апаратний кодер і один потік вводу.',
    live: 'живий екран',
    starting: 'запуск',
    disconnect: 'Від’єднатися',
    close: 'Закрити',
    disconnecting: 'Від’єднання…',
    busyBody: (who, forMin) =>
      `Цей телефон тримає хтось інший${who ? ` (${who})` : ''}${forMin ? `, уже ${forMin} хв` : ''}. Відібрати телефон ні в кого не можна: він звільниться сам, коли людина закінчить або перестане щось робити — оберіть інший телефон.`,
    postingBody: (who) =>
      `На цьому телефоні триває автоматична публікація${who ? ` (${who})` : ''} — вона тримає телефон, поки публікація не закінчиться; відібрати його не можна.`,
    preemptedByPost:
      'Автоматична публікація забрала цей телефон — це пріоритетне завдання. Телефон повернеться, коли публікація закінчиться; нічого вашого не втрачено.',
    failed: 'сесія не піднялася',
    retry: 'Спробувати ще',
    endedOnServer: 'сесію завершено на сервері',
    hubStarting: 'машина піднімає потік…',
    startupNote: (elapsed, expected) =>
      `${elapsed} с · зазвичай близько ${expected} с: сервіс просить машину, та запускає scrcpy і чекає на керування й геометрію екрана`,
    notReady: 'екран ще не готовий',
    back: 'Назад',
    home: 'Додому',
    recents: 'Останні',
    wake: 'Розбудити',
    power: 'Живлення',
    volDown: 'Тихіше (на телефоні)',
    volUp: 'Гучніше (на телефоні)',
    swipeUp: 'Свайп угору',
    swipeDown: 'Свайп униз',
    screenshot: 'Скріншот',
    screenshotSaved: 'Скріншот збережено',
    keyboard: 'Клавіатура',
    keyboardOn: 'Клавіатура: увімкнено',
    keyboardHint: 'Натискання йдуть на телефон. Esc = Назад. Вимкніть, щоб друкувати на цій сторінці.',
    keyboardTitle: 'Друкувати прямо в телефон: літери як текст, Enter/Backspace/стрілки як клавіші',
    typeHere: 'Набрати текст на пристрої…',
    send: 'Надіслати',
    gestureHint: 'Клік = тап, перетягування = свайп зі справжньою швидкістю, утримання = довгий тап.',
    sessionId: 'Id сесії',
    video: 'Відео',
    quality: 'Якість',
    qualityTitle: 'Бітрейт відео. Роздільність лишається рідною — інакше scrcpy губить дотики',
    q3: '3 Мбіт · звичайна',
    q5: '5 Мбіт · чіткіше',
    q15: '1.5 Мбіт · слабкий зв’язок',
  },

  audio: {
    title: 'Звук',
    on: 'Звук увімк.',
    off: 'Звук',
    toggleTitle: 'Звук із телефона — Opus, ~64 кбіт/с',
    gain: 'Гучність відтворення у браузері (гучність самого телефона — клавіші ⊖ ⊕)',
    tone: 'біп',
    toneTitle: 'Програти 440 Гц прямо у вихід браузера — щоб відрізнити «браузер грає в інше місце» від «декодер завис»',
    decoded: (n) => `декодовано ${n}/с`,
    ctx: (state) => `ctx=${state}`,
    gainValue: (v) => `gain ${v}`,
    fineHere: 'декодує і грає — якщо тихо, перевірте пристрій виводу на ноутбуці',
    noPackets: 'пакетів немає',
    starting: 'запуск (близько 4 с)',
    quiet: 'тиша (телефон нічого не грає)',
    kbit: (n) => `${n} кбіт/с`,
    noContext: 'браузер відмовився відкрити аудіоконтекст',
    noOpus: 'цей браузер не декодує Opus (потрібен Chrome/Edge)',
    decoderError: (msg) => `декодер: ${msg}`,
    outputError: (msg) => `вивід: ${msg}`,
    unavailable: 'звук недоступний',
    toneReport: (state, channels, chain) =>
      `тест: 440 Гц прямо у вихід, ctx=${state}, ${channels} кан., ${chain}. Якщо не чуєте — перевірте пристрій виводу й системний мікшер, а не телефон.`,
    chainGain: (v) => `gain каналу ${v}`,
    chainClosed: 'канал не відкрито',
  },

  input: {
    xiaomiSecurity: 'телефон не приймає тапи й клавіші з комп’ютера. На Xiaomi / Redmi / POCO: Налаштування → Додаткові налаштування → Для розробників → увімкни «Налагодження USB (Налаштування безпеки)» (потрібні SIM-картка і Mi-акаунт), потім перепідключи телефон',
    notDelivered: (label: string, hint: string) => `${label}: не доставлено — ${hint}`,
    channelDown: 'канал керування впав — перепідключення',
    reconnecting: 'перепідключаю канал керування…',
    touch_down: 'дотик',
    touch_move: 'рух',
    touch_up: 'відпускання',
    tap: 'тап',
    swipe: 'свайп',
    text: 'текст',
    key: 'клавіша',
    sent: (label) => `${label} → телефон`,
    failed: (label) => `${label}: не дійшло`,
    channelOpen: 'канал вводу відкрито',
  },

  logs: {
    title: 'Лог телефона',
    needSession: 'відкрийте сесію, щоб читати її лог',
    turnOn: 'Показати лог',
    turnOff: 'Сховати лог',
    toggleTitle: 'Читання логу займає той самий USB-кабель, що й тапи з відео — увімкнено лише на ваш запит',
    live: 'живий',
    closed: 'закрито',
    packagePlaceholder: 'пакет (порожньо = увесь телефон)',
    packageLabel: 'Фільтр за пакетом',
    matchPlaceholder: 'містить…',
    matchLabel: 'Фільтр за текстом',
    apply: 'Застосувати',
    clear: 'Очистити',
    follow: 'слідкувати',
    waiting: 'чекаю на перші рядки…',
    started: (pkg, match, replaying) =>
      `--- лог запущено · ${pkg ? `пакет ${pkg}` : 'увесь телефон'}${match ? ` · містить «${match}»` : ''}${replaying ? ` · відтворюю до ${replaying} рядків, які ще тримає телефон` : ''}`,
    hint: 'Ваші тапи й клавіші підсвічено (▸). Краші й ANR лишаються завжди, хто б їх не записав.',
    offHint: 'Лог вимкнено. Увімкніть, щоб бачити, що робить застосунок, поки ви керуєте телефоном — він підвантажить те, що телефон ще пам’ятає.',
  },

  videos: {
    results: 'Що принесло',
    viewsWord: 'перегл.',
    likesWord: 'лайк.',
    postsAccounts: (posts: number, accounts: number) => `${posts} пост. з ${accounts} акаунт.`,
    lastPosted: (when: string) => `востаннє ${when}`,
    history: (n: number) => `історія · ${n}`,
    bestPost: (views: string) => `найкращий: ${views}`,
    neverPosted: 'ще ніде не публікувалось',
    orderNew: 'Найновіші',
    orderBest: 'Що стріляє',
    orderNever: (n: number) => `Ще не постилось · ${n}`,
    notReadYet: 'цифр ще немає',
    openPost: 'відкрити пост',
    noLink: 'без посилання',
    directionFor: 'Напрям для завантаження…',
    pickDirectionFirst: 'Спершу оберіть напрям — відео належить одному напряму й піде лише на його телефони.',
    noDirectionsYou: 'У вас ще немає напряму — адмін додає його на сторінці «Користувачі»',
    direction: 'Напрям',
    setDirection: 'вказати напрям…',
    moveDirection: 'змінити…',
    noDirection: 'без напряму — нікуди не піде',
    allDirections: (n: number) => `Усі · ${n}`,
    withoutDirection: (n: number) => `Без напряму · ${n}`,
    title: 'Відео',
    sub: 'Завантажте раз — потім розішліть на будь-які машини й телефони',
    upload: 'Завантажити відео',
    dropTitle: 'Перетягніть .mp4 / .mov / .webm сюди або клацніть, щоб обрати',
    dropBody: 'Великі файли йдуть частинами по 8 МБ і продовжуються після обриву зв’язку.',
    hashing: 'рахую контрольну суму…',
    uploaded: (name) => `${name} завантажено`,
    rejected: 'сервер відхилив файл (не збіглася контрольна сума)',
    deleted: (name) => `${name} видалено`,
    readError: (msg) => `не вдалося прочитати список відео: ${msg}`,
    none: 'відео ще немає',
    file: 'файл',
    size: 'розмір',
    state: 'стан',
    uploadedBy: 'завантажено',
    titleLabel: 'Назва відео',
    renameTitle: 'Натисніть, щоб дати відео назву; вона показується замість імені файлу. Порожня — повертає ім’я файлу.',
    renamed: (name) => `тепер називається ${name}`,
    status: { uploading: 'завантажується', ready: 'готове', error: 'помилка' },
    distribute: 'Розіслати',
    download: 'Скачати',
    delete: 'Видалити',
    deleteTitle: (name) => `Видалити ${name}?`,
    deleteBody: 'Файл прибирається з сервера. Копії, що вже на телефонах, лишаються; розсилка, що ще триває, блокує видалення.',
  },

  distribute: {
    otherDirection: 'телефон іншого напряму — відео піде лише на телефони свого напряму',
    noDirectionPhone: 'без напряму',
    title: (name) => `Розіслати ${name}`,
    body: 'Кожна машина скачує файл один раз і копіює його в галерею кожного обраного телефона (Movies/TikTokHub). Публікацію в TikTok далі роблять на телефоні, з його живого екрана.',
    loading: 'шукаю машини…',
    phonesOnline: (online, total) => `${online} з ${total} телефонів онлайн`,
    allOnline: 'усі телефони онлайн',
    someOf: (n, total) => `${n} з ${total} телефонів`,
    send: (machines) => (machines === 1 ? 'Надіслати на 1 машину' : `Надіслати на ${machines} машин`),
    sending: 'Надсилаю…',
    started: (machines) => `Розсилку запущено на ${machines} машин(і)`,
    uniquify: 'Унікалізувати для кожного телефона',
    uniquifyHint: 'кожен телефон отримує свій варіант: 25–30 % зрізано зверху або знизу, на цьому місці фон і напівпрозорий кліп-оверлей',
    capacity: (phones, capacity) => `${phones} телефонів · джерел вистачить на ${capacity}`,
    notEnoughSources: (needed, available) =>
      `${needed} телефонам потрібно ${needed} різних варіантів, а джерел вистачає лише на ${available} — завантажте ще оверлеїв або фонів чи оберіть менше телефонів`,
    delaysHint: 'Надсилання йде з розкидом: до 5 хв між машинами, до 10 хв між телефонами однієї машини.',
    card: 'Заставка',
    cardHint: 'статичне зображення (ваш логотип) на кілька секунд у кожному варіанті',
    cardNone: 'без заставки',
    cardUpload: 'Завантажити заставку…',
    cardPlacement: { start: 'на початку', end: 'у кінці', both: 'на початку й у кінці' },
    cardSeconds: 'секунд',
    publish: 'Опублікувати в TikTok після доставки',
    publishWith: (name) => `активний сценарій: ${name}`,
    publishNone: 'немає активного сценарію — публікації не буде; запишіть його з живої сесії',
    cardRetention: 'Заставка на початку коштує переглядів: перші 1–2 секунди вирішують, чи пролистнуть ролик. Краще в кінець або інтро коротше 2 с.',
  },

  distributions: {
    title: 'Розсилки',
    sub: 'Кожне надсилання відео на машини й телефони, найновіші зверху',
    readError: (msg) => `не вдалося прочитати розсилки: ${msg}`,
    none: 'ще нічого не розсилали',
    video: 'відео',
    machines: 'машини',
    phones: 'телефони',
    state: 'стан',
    started: 'запущено',
    doneOf: (done, total) => `${done}/${total} готово`,
    failed: (n) => `${n} не вдалося`,
    status: { running: 'триває', done: 'готово', partial: 'частково', error: 'не вдалося', cancelled: 'зупинено' },
    target: { pending: 'очікує', pushing: 'надсилається', done: 'на телефоні', error: 'не вдалося', cancelled: 'скасовано' },
    uniquify: 'Унікалізація',
    variant: { queued: 'варіант у черзі', rendering: 'рендер', done: 'варіант готовий', error: 'варіант не вдався', none: '', cancelled: 'рендер скасовано' },
    attempt: (n) => `спроба ${n}`,
    rendering: (n) => `${n} у рендері`,
    variantsFailed: (n) => `${n} не вдалося після 3 спроб`,
    publishTitle: 'Публікація',
    publishState: { none: '', waiting: 'публікація чекає', running: 'публікується…', done: 'опубліковано', error: 'публікація не вдалася', skipped: 'не публікувалося', cancelled: 'публікацію скасовано', by_hand: 'чекає, поки Claude опублікує', unconfirmed: 'опубліковано? ще не бачили', not_found: 'немає на профілі' },
    unconfirmedTitle: 'Сценарій виконав свої тапи, але читання профілю ще не бачило цього поста. «Опубліковано» буде, коли профіль його покаже (читання — приблизно через годину після поста).',
    byHandTitle: 'Запущено через Claude: відео на телефоні, і Claude публікує його сам, дивлячись на екран, — без сценарію наосліп. «Опубліковано» — коли Claude записав посилання.',
    byClaude: 'публікує Claude, дивлячись на екран',
    openPost: 'відкрити пост ↗',
    publishIn: (s) => (s >= 60 ? `публікація через ${Math.ceil(s / 60)} хв` : `публікація через ${s} с`),
    publishFailedAt: (step) => `збій на кроці ${step + 1}`,
    publishScreenshot: 'екран у момент збою',
    publishRetry: 'Опублікувати ще раз',
    release: 'Відпустити',
    released: (name: string) => `${name}: відпущено — доставка почалась`,
    heldNote: 'на паузі — перегляньте варіанти й відпустіть',
    viewVariant: 'переглянути варіант',
    retryPush: 'Доставити ще раз',
    pushRetried: (device: string, n: number, of: number) => `доставляю на ${device} ще раз (спроба ${n} з ${of})`,
    pushTries: (n: number, of: number) => `повторів доставки: ${n} з ${of}`,
    pushTriesUsed: 'спроби вичерпано — гляньте телефон, потім новий пост',
    publishRetried: (device) => `публікацію запущено знову на ${device}`,
    publishLog: 'лог публікації',
    releaseIn: (s) => (s >= 60 ? `надсилання через ${Math.ceil(s / 60)} хв` : `надсилання через ${s} с`),
    stop: 'Зупинити',
    stopTitle: (name) => `Зупинити розсилку ${name}?`,
    stopBody: 'Рендери знімаються з черги, поточний ffmpeg убивається, на телефони більше нічого не піде. Те, що вже на телефонах, залишається. Скасувати це не можна.',
    stopped: (name) => `розсилку ${name} зупинено`,
    delete: 'Видалити',
    deleteTitle: (name) => `Видалити розсилку ${name} зі списку?`,
    deleteBody: 'Зникне лише запис про розсилку. Відео та його варіанти залишаються.',
    deleted: (name) => `розсилку ${name} видалено`,
    back: '← Усі розсилки',
    showLog: 'лог машини',
    hideLog: 'сховати лог',
    emptyLog: '(машина ще нічого не надрукувала)',
  },

  scenarios: {
    title: 'Сценарії публікації',
    sub: 'Що людина зробила один раз у живій сесії; кожен телефон повторює це після доставки відео',
    rule: 'Запис робиться з Робочого простору: відкрийте телефон, вийдіть на домашній екран (або в TikTok), натисніть «Записати сценарій», пройдіть увесь шлях публікації, зупиніть, назвіть. Відтворення починається з того екрана, де почався запис. Активний рівно один сценарій — він запускається в кожній розсилці. Не друкуйте справжній підпис під час запису: він піде один в один на всі телефони. Надрукуйте слово-заглушку і позначте цей крок як підпис; пост без підпису його пропускає.',
    readError: (msg) => `не вдалося прочитати сценарії: ${msg}`,
    none: 'сценаріїв ще немає — запишіть із живої сесії',
    active: 'активний',
    activate: 'Зробити активним',
    deactivate: 'Зняти',
    steps: (n) => `кроків: ${n}`,
    recordedOn: (d) => `записано на ${d}`,
    tryOn: 'Перевірити на телефоні',
    tryPick: 'оберіть телефон…',
    tryStarted: (device) => `сценарій запущено на ${device}`,
    tryLog: 'лог запуску',
    rename: 'Перейменувати',
    delete: 'Видалити',
    deleteTitle: (name) => `Видалити сценарій ${name}?`,
    deleteBody: 'Розсилки, що вже тривають, зберігають свою копію.',
    deleted: (name) => `${name} видалено`,
    saved: (name) => `${name} збережено`,
    hasText: 'є введення тексту',
    captionStep: 'крок підпису',
    markCaption: 'це підпис',
    unmarkCaption: 'не підпис',
    captionHint: 'Позначте текстовий крок, де друкується підпис: пост вставить туди свій текст замість записаного. Без позначки пост із підписом не запуститься; пост без підпису пропускає цей крок.',
    captionMarked: 'крок підпису задано',
    stepKinds: { tap: 'тап', swipe: 'свайп', text: 'текст', key: 'клавіша', wait: 'пауза', launch: 'запуск', stop: 'стоп' },
  },

  posts: {
    notYoursEditor: 'Цей пост створив хтось інший: змінити його може лише власник або адміністратор.',
    title: 'Пости',
    sub: 'Відео, анімований банер, підпис, унікалізація, телефони — готується один раз, запускається один раз',
    none: 'постів ще немає — оберіть готове відео, щоб почати',
    wizard: {
      title: 'Кроки поста',
      video: 'Відео й підпис',
      optional: 'необов’язково',
      done: 'готово',
      needVideo: 'оберіть відео',
      needText: 'напишіть підпис',
      needPhones: 'оберіть телефони',
      needCheck: 'натисніть «Перевірити»',
    },
    newPick: 'Новий пост з відео…',
    video: 'Відео',
    text: 'Підпис',
    textPlaceholder: 'Необов’язково. Текст поста: хештеги, емодзі, будь-яка мова…',
    phones: 'Телефони',
    phonesSub: 'Кожен телефон отримує свій унікалізований варіант з банером, потім активний сценарій публікує його з цим підписом',
    phone: 'телефон',
    stage: 'етап',
    banner: 'Банер',
    bannerNone: 'без банера',
    bannerUpload: 'Завантажити банер…',
    bannerHint: '.webm / .mov / .gif з прозорістю, накладається на готовий кадр — поверх смуги теж, тому ніколи не зрізається. Вписується у свою область зі збереженням пропорцій — не розтягується і не обрізається — і кріпиться до верхнього або нижнього краю.',
    box: { width: 'ширина', height: 'висота', anchor: 'край', margin: 'відступ від краю', top: 'згори', bottom: 'знизу' },
    strip: {
      title: 'Унікалізація',
      sub: 'У кожного телефона з кадру зрізається смуга й заповнюється фоном з напівпрозорим кліпом-оверлеєм. Кожен телефон бере свої значення всередині цих діапазонів.',
      side: 'сторона зрізу',
      sides: { top: 'згори', bottom: 'знизу', random: 'випадково на телефон' },
      height: 'висота смуги',
      opacity: 'прозорість оверлея',
      min: 'мін',
      max: 'макс',
      rangeHint: 'Однакові мін і макс фіксують значення на всіх телефонах. Попередній перегляд показує максимальну висоту й прозорість, і верх — коли сторона випадкова.',
      exampleOverlay: 'оверлей для перегляду',
      exampleBackground: 'фон для перегляду',
      exampleDefault: (name) => `найраніший (${name})`,
      exampleNone: 'ще нічого не завантажено',
      exampleHint: 'Лише для перегляду: телефони беруть свою пару оверлей + фон з усього каталогу.',
      sound: 'Звук',
      pitch: 'зсув висоти тону',
      music: 'гучність музики',
      soundHint: 'Тон зсувається вгору або вниз на випадкову величину з діапазону, довжина не змінюється. Музика — випадковий тихий шматок випадкового завантаженого треку; 0–0 = без музики.',
      reset: 'Повернути типові',
    },
    cardSub: 'Статична картинка (ваш логотип) на кілька секунд на початку та/або в кінці кожного варіанта. Заставки завантажуються на сторінці джерел.',
    preview: 'Попередній перегляд',
    previewHint: 'Точний кадр: те, що потрапить у фінальний файл, зі смугою максимальної висоти з джерел для перегляду. У русі: смуга й банер анімуються поверх відео в браузері.',
    previewFrame: 'точний кадр',
    previewMotion: 'у русі',
    previewAt: 'на',
    previewLoading: 'рендеримо кадр…',
    previewNoVideo: 'оберіть відео, щоб побачити попередній перегляд',
    previewCaption: 'підпис, як його покаже TikTok (не частина файлу)',
    overlayTitle: 'Текст на відео',
    overlaySub: 'Впікається в картинку на кожному телефоні. Окремо від підпису.',
    overlayNone: 'без тексту на відео',
    overlayOn: 'додати текст на відео',
    overlayText: 'Текст',
    overlayFromCaption: 'Взяти з підпису',
    overlayBox: { nx: 'по горизонталі', ny: 'по вертикалі', size: 'розмір', width: 'макс. ширина' },
    overlayColor: 'колір тексту',
    overlayBackground: 'підкладка',
    overlayBackgroundOpacity: 'прозорість підкладки',
    editTitle: 'Чернетка поста',
    editSub: 'Зберігається під час редагування; нічого не надсилається до кнопки «Запустити»',
    save: { saved: 'збережено', saving: 'збереження…', dirty: 'не збережено' },
    launchCard: 'Запуск',
    check: 'Перевірити',
    launch: 'Запустити',
    launchTitle: (n) => `Опублікувати на ${n} телефонах?`,
    launchHeld: 'Запустити з переглядом',
    launchHeldBody: 'Варіанти відрендеряться й чекатимуть: відкрийте варіант кожного телефона в розсилці, потім «Відпустити» — до того нічого не доставляється.',
    launchBody: 'Чернетка фіксується як є. Кожен телефон отримує свій варіант, потім активний сценарій публікує його з підписом. Це відбувається один раз; телефон з помилкою можна опублікувати знову вручну.',
    launched: (machines) => `Пост запущено на ${machines} машині(ах)`,
    launchedTitle: 'Запущений пост',
    readyToLaunch: (n, scenario) => `Готово: ${n} телефонів, сценарій «${scenario}».`,
    openDistribution: 'Відкрити розсилку',
    status: { draft: 'чернетка', launched: 'запущено' },
    stages: { rendering: 'рендер', ready: 'готово', pushing: 'доставка', waiting: 'на телефоні, пауза перед публікацією', unconfirmed: 'ще не бачили', publishing: 'публікація', done: 'готово', error: 'помилка', cancelled: 'зупинено', by_hand: 'чекає на Claude', not_posted: 'не опубліковано' },
    failedAt: { rendering: 'рендер не вдався', pushing: 'доставка не вдалася', publishing: 'публікація не вдалася' },
    failedCount: (n) => `${n} з помилкою`,
    problems: {
      post_two_sites: 'у пості посилання на два різні сайти — один акаунт веде лише на один сайт; лиште один',
      account_other_site: 'ці акаунти вже ведуть на інший сайт — один акаунт веде лише на один сайт',
      phone_unreachable: 'комп не бачить ці телефони (offline або adb unauthorized) — приберіть їх або підтвердіть «Дозволити налагодження USB» на телефоні',
      video_no_direction: 'у відео немає напряму — вкажіть його на сторінці «Відео»',
      phone_other_direction: 'телефони іншого напряму — відео піде лише на телефони свого напряму',
      account_banned: 'акаунт у бані — не постить',
      account_limited: 'акаунт обмежений — не постить, доки знову не стане активним',
      daily_limit: 'акаунт уже виклав свій ліміт за добу (3 пости, на прогріві — 1)',
      too_soon: 'акаунт постив менше ніж 2 години тому',
      no_directions: 'у вас ще немає напряму — адмін додає його на сторінці «Користувачі»',
      not_your_direction: 'це відео іншого напряму, ніж ваші',
      video_not_ready: 'відео відсутнє або ще не завантажене',
      banner_not_ready: 'банер відсутній або ще не завантажений',
      no_targets: 'оберіть хоча б одну машину або телефон',
      no_devices: 'жоден з обраних телефонів не в мережі',
      not_enough_sources: 'замало пар оверлей × фон для стількох телефонів — завантажте джерела або оберіть менше телефонів',
      no_scenario: 'немає активного сценарію публікації',
      no_caption_step: 'в активному сценарії не позначено крок підпису (Сценарії → «це підпис»)',
      hub_offline: 'обрана машина не в мережі',
      device_not_on_hub: 'обраний телефон не на цій машині',
    },
    delete: 'Видалити',
    deleteTitle: 'Видалити цей пост?',
    deleteBody: 'У запущеного поста розсилка лишається; видаляється лише запис поста.',
    deleted: 'пост видалено',
  },

  sources: {
    groupVariant: 'Унікалізація — кожен телефон отримує свій варіант відео',
    groupPost: 'Оформлення постів — обирається для кожного поста чи розсилки',
    title: 'Джерела для унікалізації',
    sub: 'Що підмішується у варіант кожного телефона: оверлеї та фони для смуги, музика під звук, заставки на вибір',
    rule: 'Варіант = один кліп-оверлей на одному фоні (сторона зрізу та прозорість додаються випадково). Кожен телефон однієї розсилки отримує свою пару; наступне відео знову бере весь каталог. Ємність — на скільки телефонів вистачить однієї розсилки. Музика не рахується: випадковий тихий шматок випадкового треку підкладається під кожен варіант автоматично.',
    capacity: (n) => `вистачить на ${n} телефонів`,
    readError: (msg) => `не вдалося прочитати джерела: ${msg}`,
    kind: { overlay: 'Кліпи-оверлеї', background: 'Фони', music: 'Музика', card: 'Заставки', banner: 'Банери' },
    kindHint: {
      overlay: 'короткі .mp4 / .mov / .webm, зациклені й накладені на смугу з прозорістю, заданою в пості (типово 55–75 %)',
      background: '.jpg / .png, заповнює зрізану смугу під оверлеєм',
      music: '.mp3 / .m4a / .wav — випадковий шматок на 2–5 % гучності з плавним початком і кінцем під кожним варіантом; використовуйте вільні від прав треки',
      card: '.jpg / .png, ваш логотип на чорному; обирається в діалозі Distribute або в редакторі поста',
      banner: '.webm / .mov / .gif з прозорістю — анімований кліп, який пост кладе поверх кадру; розміщується й налаштовується в редакторі поста',
    },
    none: { overlay: 'кліпів-оверлеїв ще немає', background: 'фонів ще немає', music: 'музики ще немає — у варіантів лишається лише вихідний звук', card: 'заставок ще немає', banner: 'банерів ще немає' },
    upload: 'Завантажити',
    files: (n: number) => `${n} ${n % 10 === 1 && n % 100 !== 11 ? 'файл' : [2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100) ? 'файли' : 'файлів'}`,
    uploaded: (name) => `${name} завантажено`,
    delete: 'Видалити',
    deleted: (name) => `${name} видалено`,
    deleteTitle: (name) => `Видалити ${name}?`,
    deleteBody: 'Уже відрендерені варіанти лишаються; нові розсилки його не використають, ємність зменшиться.',
  },

  account: {
    label: 'Акаунт TikTok на цьому телефоні',
    placeholder: '@акаунт',
    none: 'вказати акаунт TikTok',
    editTitle: 'Який акаунт TikTok залогінений на цьому телефоні. Лише мітка — один акаунт живе на одному телефоні.',
    set: (account, phone) => `${account} тепер на ${phone}`,
    cleared: (phone) => `мітку акаунта знято з ${phone}`,
    inUse: (account, device) => `${account} уже на ${device} — один акаунт живе на одному телефоні`,
  },

  simNumber: {
    label: 'Номер SIM у цьому телефоні',
    placeholder: '+380 67 123 45 67',
    none: 'додати номер',
    editTitle: 'Номер SIM-картки в цьому телефоні, щоб було видно одразу. Один номер — один телефон.',
    set: (num, phone) => `${num} тепер на ${phone}`,
    cleared: (phone) => `номер прибрано з ${phone}`,
    inUse: (num, device) => `${num} вже на ${device} — одна SIM, один телефон`,
  },

  phoneName: {
    label: 'Назва телефону',
    editTitle: 'Натисніть, щоб назвати телефон; назва показується замість моделі всюди. Порожня — повертає модель.',
    set: (name, model) => `${model} тепер називається ${name}`,
    cleared: (model) => `${model} знову показується за моделлю`,
  },

  accountPage: {
    site: 'Сайт',
    siteNone: 'ще не закріплено — його задасть перший пост із посиланням',
    siteChange: 'змінити',
    siteSave: 'Зберегти',
    siteCancel: 'Скасувати',
    siteBy: (by: string) => `закріпив: ${by}`,
    siteConfirm: (from: string, to: string) => `Цей акаунт уже веде на ${from}, і його пости там і лишаться. Все одно змінити на ${to || 'нічого'}? Один акаунт — один сайт.`,
    unknown: 'Такого акаунта немає — можливо, посилання застаріло.',
    openPhone: 'Відкрити телефон',
    onPhone: (phone: string) => `на телефоні ${phone}`,
    profile: 'профіль у TikTok',
  },
  direction: {
    unknown: 'Такого напряму немає.',
    tabs: { stats: 'Статистика', accounts: 'Акаунти', posts: 'Публікації', links: 'Посилання', phones: 'Телефони' } as Record<string, string>,
  },
  trend: {
    dayChange: (d: string) => `за день ${d}`,
    lastDay: (day: string) => `${day} за день:`,
    bestDay: (day: string, v: string) => `найкращий день — ${day}: ${v}`,
    firstReading: (day: string) => `перше читання — ${day}; лінія наростатиме щодня, попередніх днів TikTok не показує`,
    notRead: 'ще не прочитано',
    since: (day: string) => `з ${day}`,
    overDays: (n: number) => `за ${n} дн.`,
  },
  sections: {
    directions: 'Напрями',
    accounts: 'Усі акаунти',
    publications: 'Усі публікації',
    links: 'Посилання',
    posts: 'Запуск постів',
    distributions: 'Розсилки',
    videos: 'Відео',
    machines: 'Машини',
    sources: 'Джерела',
    scenarios: 'Сценарії',
    users: 'Користувачі',
    myClaude: 'Мій Claude',
    keys: 'Ключі',
  },
  dirs: {
    title: 'Напрями',
    sub: 'що рекламуємо — і які телефони на кого працюють',
    rules: [
      'Напрям — це те, що рекламуємо: ігри, драми тощо. Дашборд, звіти й контент розкладено за напрямами.',
      'Кожен телефон належить одному напряму назавжди, разом з усіма акаунтами на ньому: з нього постять лише контент цього напряму.',
      'Телефон без напряму маркетинг не використовує: його не читає статистика і він не потрапляє у звіти. Грати на ньому й брати сесії можна як завжди.',
      'Напрям можна перейменувати й перефарбувати будь-коли; прив’язку телефону змінити не можна.',
    ],
    newName: 'Назва нового напряму, напр. Казино',
    color: 'Колір',
    add: 'Додати напрям',
    edit: 'Перейменувати / колір',
    save: 'Зберегти',
    cancel: 'Скасувати',
    counts: (phones: number, accounts: number) => `телефонів: ${phones} · акаунтів: ${accounts}`,
    noPhones: 'Ще немає телефонів — прив’яжіть їх нижче, у «Без напряму».',
    noAccounts: 'акаунтів не зареєстровано',
    status: { online: 'на зв’язку', offline: 'не на зв’язку', busy: 'зайнятий' } as Record<string, string>,
    unboundTitle: (n: number) => `Без напряму · ${n}`,
    allBound: 'Усі телефони мають напрям.',
    unboundSub: 'ці телефони маркетинг не використовує, доки адмін не прив’яже їх до напряму',
    unboundSubAdmin: 'позначте телефони, оберіть напрям і прив’яжіть — усі разом',
    pickAll: 'Позначити всі',
    pickNone: 'Зняти всі',
    toDirection: 'до напряму…',
    bind: (n: number) => `Прив’язати (${n})`,
    confirmTitle: (n: number, dir: string) => `Прив’язати ${n} тел. до «${dir}» назавжди`,
    confirm: 'Прив’язати назавжди',
  },
  marketing: {
    builtin: { games: 'Ігри', dramas: 'Драми' },
    title: 'Акаунти',
    sub: 'акаунти в телефонах за напрямами — хто живий, обмежений чи в бані',
    rules: 'Телефон належить одному напряму назавжди (прив’язує адмін на сторінці «Напрями»). Акаунт живе в одному телефоні назавжди й не видаляється — зниклий позначають «вийшов». Паролів ніде немає.',
    allDirections: 'Усі напрями',
    noBoundPhones: 'Жоден телефон ще не має напряму — спершу адмін прив’язує їх на сторінці «Напрями».',
    emailPlaceholder: 'пошта, з якою зайшли (name@gmail.com)',
    handlePlaceholder: '@нік (необов’язково)',
    handleOnly: '@нік або посилання на профіль',
    addHandle: '+ нік',
    phone: 'Телефон',
    pickPhone: 'телефон…',
    stateLabel: 'Стан',
    add: 'Додати акаунт',
    state: { warming: 'прогрів', active: 'активний', limited: 'обмежений', banned: 'бан', logged_out: 'вийшов' } as Record<string, string>,
    changeState: 'змінити стан…',
    reasonRequired: 'що побачили — обов’язково',
    reasonOptional: 'що побачили (необов’язково)',
    save: 'Зберегти',
    history: (n: number) => `історія · ${n}`,
    groupSub: (phones: number, accounts: number) => `телефонів: ${phones} · акаунтів: ${accounts}`,
    noPhonesInDirection: 'у цьому напрямі ще немає телефонів',
    noAccounts: 'на цьому телефоні акаунтів не зареєстровано',
    noDirection: 'без напряму',
    noDirectionTitle: 'ще не прив’язаний до напряму — маркетинг не може ним користуватися, доки адмін не прив’яже',
    bindButton: 'Призначити напрям',
    bindTitle: (phone: string) => `Прив’язати ${phone} до напряму`,
    bindPick: 'Оберіть напрям',
    bindConfirm: (_dir: string) => 'Прив’язати назавжди',
    bindForever: 'Це назавжди: телефон і всі акаунти на ньому належатимуть цьому напряму. Змінити можна буде лише правкою бази.',
    bindOnlyMarketing: 'Це обмежує лише маркетинг — телефон і далі бере сесії, і Claude може грати на ньому в ігри.',
    directionsTitle: 'Напрями',
    directionsSub: 'лише для адмінів: додати напрям і бачити, що в кожному',
    directionStats: (phones: number, accounts: number) => `телефонів: ${phones} · акаунтів: ${accounts}`,
    newId: 'id, напр. apps',
    newName: 'назва',
    color: 'колір',
    preview: 'вигляд',
    addDirection: 'Додати напрям',
  },
  publications: {
    title: 'Публікації',
    sub: 'кожен пост на кожному телефоні — постинг Ферми з\'являється тут сам; пости, зроблені вручну чи Claude, записуються через MCP',
    all: 'Усі',
    noLink: 'Без посилання',
    noAccount: 'Акаунт невідомий',
    summary: (n: number, noLink: number, noAccount: number) => `${n} пост. · ${noLink} без посилання · ${noAccount} з невідомим акаунтом`,
    empty: 'Поки нічого. Завершений постинг з\'являється тут протягом хвилини.',
    day: (n: number) => `${n} пост.`,
    video: 'відео',
    text: 'текст',
    source: { ferma: 'постинг Ферми', recorded: 'записано', profile: 'знайдено в профілі' },
    accountBy: { phone: 'єдиний акаунт на цьому телефоні', link: 'з посилання на пост', person: 'вказала людина' },
    pickAccount: 'Який акаунт?',
    noAccounts: 'на цьому телефоні немає зареєстрованих акаунтів',
    addLink: 'Додати посилання на пост',
    linkPlaceholder: 'https://www.tiktok.com/@handle/video/…',
    open: 'Відкрити пост',
    save: 'Зберегти',
    cancel: 'Скасувати',
    onWords: 'на відео',
    phoneGone: 'телефон більше не підключений',
    noTarget: 'Без цілі',
    onlyLink: (name: string) => `Лише пости з посиланням ${name}.`,
    showAll: 'Показати всі',
    target: 'Посилання',
    targetFromText: 'з тексту поста',
    targetByPerson: 'вказала людина',
    targetReset: 'брати з тексту',
    pickTarget: 'Яке посилання в пості?',
    noTargets: 'список посилань порожній — адмін додає їх на сторінці «Посилання»',
  },

  dash: {
    phonesCount: (n) => `на ${n} телефонах`,
    title: 'Огляд',
    sub: 'все, що робить ферма, і що принесли пости',
    updated: (at) => `оновлено ${at}`,
    periods: { 1: 'Сьогодні', 7: '7 днів', 30: '30 днів', 90: '90 днів', 365: 'Рік' } as Record<number, string>,
    daysN: (n: number) => `${n} дн.`,
    customDates: 'Свої дати',
    from: 'від',
    to: 'до',
    accountsTrendsTitle: (n: number) => `Акаунти по днях · ${n}`,
    accountsTrendsSub: 'кожен акаунт: підписники, перегляди постів і лайки кожного вечора; назва відкриває акаунт',
    postsInPeriod: (n: number) => `постів за період: ${n}`,
    allDirections: 'усі напрями',
    noDirection: 'телефони без напряму',
    allPhones: 'усі телефони',
    phonePage: (name) => `Телефон ${name}`,
    backToAll: 'Назад до всієї ферми',
    openPhone: 'Відкрити телефон',
    nowTitle: 'Зараз',
    nowSub: 'уся ферма, незалежно від фільтра',
    phonesTile: 'Телефони',
    phoneStates: { free: 'вільні', posting: 'постять', held: 'тримає людина / Claude', reading: 'читають статистику', offline: 'не на зв\'язку', trouble: 'підключені, але недоступні' },
    machinesTile: 'Машини',
    machinesOnline: (on, all) => `${on} з ${all} на зв'язку`,
    distributionsTile: 'Розсилки',
    distRunning: (n) => `${n} в роботі`,
    distFinished: (done, partial, err) => `за 24 год: ${done} готово · ${partial} частково · ${err} з помилкою`,
    jobsTile: 'Завдання на телефонах',
    jobsLine: (run, queued) => `${run} виконується · ${queued} в черзі`,
    jobsDay: (done, failed) => `за 24 год: ${done} готово · ${failed} з помилкою`,
    passTile: 'Читання профілів',
    passOn: 'розклад увімкнено',
    passOff: 'розклад вимкнено',
    passRunning: (who) => `читає ${who}`,
    passDay: (n) => `${n} читань за 24 год`,
    heldTitle: 'Хто який телефон тримає',
    heldFor: (min) => `${min} хв`,
    heldPosting: 'автопостинг',
    heldReading: 'читає статистику — можна брати',
    runningTitle: 'Розсилки в роботі',
    pushed: (done, all) => `залито ${done}/${all}`,
    rendered: (done, all) => `унікалізовано ${done}/${all}`,
    published: (done, all, failed) => `опубліковано ${done}/${all}${failed ? ` · ${failed} з помилкою` : ''}`,
    nothingRunning: 'Зараз нічого не розсилається.',
    nobodyHolds: 'Зараз ніхто не тримає телефон.',
    alertsTitle: 'Потребує уваги',
    alertsNone: 'Усе гаразд — нічого не потребує уваги.',
    more: (n) => `і ще ${n}`,
    alert: {
      not_recommended: (n) => `TikTok не показує в рекомендаціях («Для тебе»): ${n} пост(ів) — органічного охоплення немає`,
      hubs_offline: (n) => `Машин не на зв'язку: ${n}`,
      phones_offline: (n) => `Телефонів не на зв'язку: ${n}`,
      phones_trouble: (n) => `Підключені, але недоступні (adb): ${n}`,
      battery_low: (n) => `Майже розряджені й не заряджаються: ${n}`,
      battery_weak_power: (n) => `На кабелі, який не заряджає: ${n}`,
      hot: (n) => `Перегріваються: ${n}`,
      accounts_banned: (n) => `Акаунтів у бані: ${n}`,
      accounts_limited: (n) => `Обмежених акаунтів: ${n}`,
      profile_trouble: (n) => `Останнє читання профілю знайшло проблему: ${n} акаунт(ів)`,
      distributions_failed: (n) => `Розсилок за 24 год, що опублікувались не всюди: ${n}`,
      jobs_failed: (n) => `Завдань на телефонах з помилкою за 24 год: ${n}`,
      doubtful: (n) => `Пости, зіставлені не напевно, — вирішує людина: ${n} акаунт(ів)`,
      not_found: (n) => `Постів Ферми немає в профілі: ${n} акаунт(ів)`,
      phones_unbound: (n) => `Телефонів без напряму (не читаються, не рахуються): ${n}`,
      phones_no_account: (n) => `Телефонів з напрямом, але без акаунта: ${n}`,
      accounts_no_email: (n) => `Акаунтів без пошти: ${n}`,
      posts_no_link: (n) => `Постів без цільового посилання: ${n}`,
      posts_no_account: (n) => `Постів без акаунта: ${n}`,
      links_unlisted: (n) => `Адрес у постах, яких немає в списку посилань: ${n}`,
      accounts_two_sites: (n: number) => `${n} акаунт(и) вже ведуть на два різні сайти — так бути не повинно`,
      links_shared: (n) => `Посилань на багатьох телефонах — нитка, що пов'язує акаунти: ${n}`,
      pass_off: () => 'Розклад читання профілів вимкнено — цифри оновлюються лише вручну',
    },
    dirPeriodTitle: (period) => `По напрямах · ${period}`,
    dirPeriodSub: 'пости, що вийшли за період, і скільки за нього додалося переглядів, лайків і підписників — порівняно з відрізком перед ним; акаунти з проблемами — на зараз',
    lineSince: (day, now) => `зараз ${now} · читаємо з ${day}, лінія — після 3 днів`,
    lineFrom: (day) => `з ${day}`,
    yesterdayTitle: (day) => `Вчора, ${day}`,
    yesterdaySub: 'доба за Києвом; перегляди, лайки й підписники — те, що додалося за цю добу',
    periodTitle: 'По напрямах',
    periodSub: (from) => `від ${from}, порівняно з таким самим відрізком перед ним`,
    unbound: 'Без напряму',
    posts: 'пости',
    views: 'перегляди',
    likes: 'лайки',
    comments: 'коментарі',
    shares: 'поширення',
    followers: 'підписники',
    gained: 'додалось',
    accountStatsTitle: 'Статистика акаунта',
    profileViews: 'Перегляди профілю',
    hintFollowers: 'скільки підписників було на кінець кожного дня',
    hintViews: 'перегляди всіх постів, видимих у профілі, разом — на кінець дня',
    hintLikes: 'усі лайки акаунта (число в профілі) на кінець дня',
    hintPosts: 'скільки постів вийшло за кожен день',
    hintProfileViews: 'скільки разів відкривали профіль — на кінець дня',
    totalNow: (v) => `усього зараз ${v}`,
    inPeriod: (v: string) => `${v} за період`,
    postsInPeriodShort: 'вийшло за період',
    kpiTitle: 'Головне за період',
    clicks: 'Переходи за посиланнями',
    clicksNotYet: 'ще не збираються',
    accTableTitle: (n: number) => `Акаунти · ${n}`,
    accTableSub: 'усі акаунти в одній таблиці — клік на заголовок сортує; назва відкриває акаунт',
    colAccount: 'Акаунт',
    colFollowersLine: 'Підписники по днях',
    colFollowers: 'Підписники',
    colFollowersGained: 'За період',
    colViews: 'Перегляди',
    colViewsGained: 'За період',
    colPosts: 'Пости',
    colRead: 'Прочитано',
    numbersNotYet: 'перегляди, лайки й підписники ще не прочитані з телефонів',
    firstReadInPeriod: 'перше читання',
    notRecommended: 'не в рекомендаціях «Для тебе»',
    notRecommendedLong: 'TikTok не показує цей пост у рекомендаціях («Для тебе») — органічного охоплення немає',
    foundPost: 'Пост із профілю (не через Ферму)',
    trendsTitle: 'Статистика по днях',
    trendsSub: (n: number) => `як ріс кожен напрям за ${n} дн. — де він був кожного вечора; пропуск — день ще не прочитано`,
    viewsAll: 'Перегляди постів',
    likesAll: 'Лайки акаунтів',
    statsTitle: 'Статистика напряму',
    fromProfile: 'з профілю',
    notRead: 'ще не прочитано',
    best: 'Найкращий пост',
    noBest: 'жоден пост ще не виріс',
    trouble: 'Проблемні акаунти',
    noTrouble: 'усі акаунти в порядку',
    phonesAccounts: (p, on, a) => `${p} телефонів (${on} на зв'язку) · ${a} акаунтів`,
    followersTotal: (n) => `${n} підписників загалом`,
    vsBefore: (sign, pct) => `${sign}${pct} до попереднього`,
    sameAsBefore: 'як і раніше',
    newSinceBefore: 'раніше не було',
    perDay: 'приріст переглядів за день',
    postsPerDay: 'постів за день',
    noReadings: 'Жоден профіль ще не прочитано, тож перегляди й підписники невідомі. Вони з\'являться після першого читання («Акаунти» → «Прочитати профіль зараз» або розклад).',
    phonesTitle: 'Телефони й акаунти',
    phonesSub: 'пости, перегляди й підписники за 7 днів',
    col: { phone: 'Телефон', direction: 'Напрям', state: 'Зараз', accounts: 'Акаунти', followers: 'Підписники', posts7: 'Пости 7 д', views7: 'Перегляди 7 д', lastPost: 'Останній пост', alerts: 'Тривоги' },
    noAccounts: 'без акаунта',
    never: 'ніколи',
    phoneAlert: {
      not_recommended: 'є пости поза рекомендаціями',
      offline: 'не на зв\'язку', trouble: 'adb', battery_low: 'розряджений', battery_weak_power: 'не заряджається', hot: 'гарячий',
      unbound: 'без напряму', no_account: 'без акаунта', account_banned: 'бан', account_limited: 'обмежений',
      account_signed_out: 'вийшов з TikTok', account_other_account: 'інший акаунт', account_no_tiktok: 'немає TikTok',
      account_failed: 'читання не вдалось', account_locked: 'PIN-блокування',
    },
    feedExplain: 'Кожен пост за обраний період, найбільше переглядів — зверху. Цифри — з останнього разу, коли телефон відкривав пост; «Як ріс» показує, як вони змінювались між читаннями.',
    feedUnread: (n: number, all: number) => `${n} з ${all} постів телефони ще не відкривали — цифр по них поки немає. Вони з'являться після наступних читань профілю.`,
    postNotRead: 'Цифр ще немає — телефон цей пост ще не відкривав.',
    accountUnknown: 'акаунт невідомий',
    carries: (links: string) => `посилання: ${links}`,
    hintPostViews: 'скільки переглядів було в пості на момент кожного читання',
    hintPostLikes: 'скільки лайків — на момент кожного читання',
    everyReading: (n: number) => `усі читання (${n})`,
    feedTitle: 'Пости за результатом',
    feedSub: (shown, all) => all > shown ? `${shown} з ${all} за період` : `${all} за період`,
    feedNone: 'За цей період постів немає.',
    gainedInPeriod: (n) => `+${n} переглядів за період`,
    found: 'знайдено в профілі',
    openPost: 'Відкрити в TikTok',
    growth: 'Як ріс',
    growthNone: 'Поки прочитано лише раз — лінія з\'явиться після наступного читання.',
    noPicture: 'без картинки',
    battery: (n) => `${n}%`,
  },

  profile: {
    title: 'Читання профілів',
    sub: 'телефони відкривають свій профіль TikTok і читають, що зібрали пости — лише читання, з найнижчим пріоритетом',
    rules: 'Лише читання: вкладка профілю, пости, «Назад» і «Додому» — без лайків і без набору тексту. Телефон, який хтось тримає, пропускається; будь-хто, хто бере телефон (постинг, людина, Claude), одразу зупиняє читання. Один телефон за раз; кожен акаунт раз на 6 годин і через годину після кожного нового поста; лише телефони з напрямом. Блокування PIN-кодом не чіпаємо.',
    autoOn: 'Розклад увімкнено',
    autoOff: 'Розклад вимкнено — читання лише вручну',
    switchOn: 'Увімкнути розклад',
    switchOff: 'Вимкнути розклад',
    readingNow: (who: string) => `зараз читається: ${who}`,
    readNow: 'Прочитати профіль зараз',
    started: 'Читаю — хвилина-дві. Результат з’явиться тут.',
    never: 'ще не читали',
    when: (at: string) => `прочитано ${at}`,
    counts: (followers: string, likes: string, posts: number, views: string) => `${followers} слідкувачів · ${likes} вподобайок · прочитано постів: ${posts}, переглядів ${views}`,
    outcome: {
      partial: 'обірвалося посередині — повтор протягом години',
      ok: 'прочитано', locked: 'телефон заблоковано PIN-кодом', busy: 'телефон був зайнятий — пропущено',
      evicted: 'зупинено: телефон хтось узяв', no_tiktok: 'TikTok не відкрився', signed_out: 'у TikTok ніхто не увійшов',
      banned: 'TikTok показує бан', other_account: 'на телефоні інший акаунт', failed: 'читання не вдалося',
    } as Record<string, string>,
    doubtful: (n: number) => `${n} пост. не зіставлено напевно — вирішує людина`,
    notFound: (n: number) => `${n} пост. Ферми немає в профілі`,
    details: 'Що прочитано',
    match: { sure: 'своя публікація', doubtful: 'під питанням', found: 'знайдено в профілі' } as Record<string, string>,
    statNames: { views: 'перегляди', likes: 'вподобайки', comments: 'коментарі', shares: 'поширення', saves: 'збереження' } as Record<string, string>,
    statsAt: (at: string) => `станом на ${at}`,
    aiLabel: 'TikTok позначає як згенероване ШІ',
    phoneReading: 'читає статистику — можна брати',
  },

  links: {
    title: 'Посилання',
    sub: 'куди пости ведуть людей — сайт, ТГ-канал, будь-що — і які пости, телефони й акаунти їх несли',
    rules: 'Посилання в пості — рівно те, що тут, без наших коротких лінків і редиректів: один домен на всіх акаунтах їх пов’язує. Тому кліки бачить лише власник посилання (аналітика сайту); тут — усі пости, що його несли. Яке посилання в пості, Ферма читає з тексту на відео й підпису.',
    listTitle: 'Список',
    listSub: (n: number) => `посилань: ${n}`,
    empty: 'Поки порожньо. Адмін додає посилання вище — або з тих, що вже знайдено в постах, нижче.',
    urlPlaceholder: 'адреса, як у пості: manyplay.fun, https://t.me/…',
    namePlaceholder: 'назва (необов’язково)',
    direction: 'Напрям',
    anyDirection: 'будь-який напрям',
    add: 'Додати',
    carried: (pubs: number, phones: number, accounts: number) => `${pubs} пост. · телефонів: ${phones} · акаунтів: ${accounts}`,
    notPosted: 'ще в жодному пості',
    span: (from: string, to: string) => from === to ? from : `${from} – ${to}`,
    sharedWidely: (phones: number, at: number) => `стоїть на ${phones} телефонах (поріг ${at}) — одна адреса на багатьох акаунтах може їх пов’язати`,
    otherDirection: 'його несли пости іншого напряму',
    retire: 'Більше не просуваємо',
    unretire: 'Повернути',
    retiredList: (n: number) => `не просуваються: ${n}`,
    unlistedTitle: 'Знайдено в постах, але не в списку',
    unlistedSub: 'адреси з тексту на відео чи підпису — додайте ті, що є цілями',
    foundIn: (n: number, last: string) => `у ${n} пост., останній ${last}`,
    addFound: 'Додати в список',
  },

  machines: {
    usb: {
      level: (pct) => `${pct}%`,
      charging: 'заряджається',
      weakShort: 'розряджається',
      weakCharge: 'на кабелі, але розряджається — порт хаба не встигає',
      ranFlat: (pct, at) => `розрядився (останній заряд ${pct}%, ${at}) — увімкни кнопкою`,
      seat: (hub, place) => `хаб ${hub} · місце ${place}`,
      hubOnly: (hub) => `хаб ${hub}`,
      group: (hub, n) => `Хаб на порту ${hub} комп'ютера · телефонів: ${n}`,
      unknownPort: 'порт USB ще невідомий',
      port: (path) => `USB ${path}`,
      portTitle: (route) => `де висить: ${route}`,
      route: (bus, ports) => `шина ${bus} · порт комп'ютера ${ports[0]}${ports.slice(1).map((p) => ` → порт хаба ${p}`).join('')}`,
      since: (time) => `відпав о ${time}`,
      gone: 'не видно на USB — від\'єднаний або хаб без живлення',
      waiting: 'на кабелі — машина перепідключить сама',
      trying: (n, max) => `машина перепідключає (спроба ${n} з ${max})`,
      gaveUp: (max) => `машина пробувала ${max} рази — потрібна людина`,
      stateHint: (state) => state === 'unauthorized'
        ? 'на кабелі, чекає «Дозволити налагодження USB» на екрані'
        : `на кабелі, adb: ${state}`,
      dropped: 'Відпали',
      drops: (n) => `${n}× за 7 днів`,
      dropLine: (at, how) => `${at} — ${how}`,
      backByHub: 'повернула машина',
      backUnplugged: 'кабель виймали, підключили знову',
      backSelf: 'повернувся сам',
      stillOut: 'досі відпавший',
    },
    title: 'Машини',
    rule: 'Один телефон = один акаунт TikTok. Вкажіть акаунт на кожному телефоні тут; другий телефон із тим самим сервіс відхилить.',
    readError: (msg) => `не вдалося прочитати список машин: ${msg}`,
    none: 'машин ще немає',
    point: (point) => `майданчик ${point}`,
    agent: (v) => `агент ${v}`,
    onWire: 'на зв’язку',
    offline: 'офлайн',
    phones: (n) => `${n} телефон(ів)`,
    onlinePhones: (n) => `онлайн ${n}`,
    unlabelled: (n) => `${n} без мітки акаунта`,
    showPhones: 'телефони',
    hide: 'сховати',
    noPhones: 'на цій машині немає телефонів',
    deleteMachine: 'Видалити машину',
    deletePhone: 'Видалити',
    liveCannotDelete: 'Видалити можна лише офлайн-телефон — живий перереєструється з наступним heartbeat',
    onlineCannotDelete: 'Спершу зупиніть агент — підключена машина реєструє себе знову',
    deleted: (name) => `${name} видалено з нашої бази`,
  },

  confirm: {
    titleMachine: (name) => `Видалити машину ${name}?`,
    titlePhone: (name) => `Видалити телефон ${name}?`,
    ourDbOnly: 'Це прибирає запис лише з бази Ferma Hub. На машині й телефоні нічого не змінюється.',
    cascade: (n) => `Разом із нею видаляться її ${n} телефон(ів) і їхні сесії.`,
    phoneNote: 'Телефон зникне зі списків у нашій базі. Якщо його знову під’єднати до машини — зареєструється заново.',
    typeName: (name) => `Введіть ${name} для підтвердження`,
    math: (a, b, op) => `І розв’яжіть: ${a} ${op} ${b} = ?`,
    answer: 'Відповідь',
    nameMismatch: 'назва не збігається',
    mathWrong: 'неправильна відповідь',
    cancel: 'Скасувати',
    doDelete: 'Видалити',
  },

  common: {
    dash: '—', save: 'Зберегти', dismiss: 'Прибрати',
    adminOnly: 'Це може зробити лише адміністратор',
    notYours: 'Змінити або видалити це може лише власник або адміністратор',
  },

  users: {
    directions: 'Напрями',
    allDirections: 'усі (адмін)',
    noDirections: 'немає — нічого не постить',
    directionsSaved: (email: string) => `Напрями ${email} збережено`,
    title: 'Користувачі',
    sub: 'Хто може увійти і що йому дозволено. Google-акаунти з’являються тут після першого входу; парольні акаунти створюються нижче.',
    adminOnly: 'Керувати користувачами може лише адміністратор.',
    readError: (msg: string) => `не вдалося прочитати користувачів: ${msg}`,
    none: 'користувачів поки немає',
    email: 'E-mail',
    name: 'Ім’я',
    role: 'Роль',
    createdAt: 'Створено',
    signIn: 'Вхід',
    password: 'пароль',
    googleOnly: 'лише Google',
    you: 'ви',
    roles: { admin: 'адміністратор', tester: 'тестувальник' } as Record<string, string>,
    roleHint: 'Адміністратор керує телефонами, сценаріями, користувачами та чужим контентом; тестувальник працює зі своїм.',
    resetPassword: 'Задати пароль',
    newPassword: 'Новий пароль',
    minPassword: 'не менше 8 символів',
    save: 'Зберегти',
    cancel: 'Скасувати',
    delete: 'Видалити',
    deleteTitle: (email: string) => `Видалити ${email}?`,
    deleteBody: 'Людина більше не зможе увійти; її сесії завершаться одразу. Створені нею відео, пости та розсилки залишаться.',
    addTitle: 'Додати парольний акаунт',
    addSub: 'Для того, хто не має корпоративного Google-акаунта. Лише корпоративна пошта.',
    add: 'Створити',
    created: (email: string) => `${email} створено`,
    roleSaved: (email: string, role: string) => `${email} тепер ${role}`,
    passwordSet: (email: string) => `пароль для ${email} задано`,
    deleted: (email: string) => `${email} видалено`,
  },

  oauth: {
    title: 'Підключити Claude до Ferma Hub',
    asks: (name: string) => `${name} просить працювати у Ferma Hub від вашого імені.`,
    goesTo: 'Відповідь повернеться на',
    loopback: 'програму на цьому комп’ютері (Claude Code)',
    can: 'Зможе: бачити машини й телефони, брати телефон на ваше ім’я та керувати ним, завантажувати відео та вихідні матеріали, створювати й запускати пости та розсилки.',
    cannot: 'Не зможе: керувати сценаріями, телефонами, машинами, користувачами та чужим контентом.',
    revokeLater: 'Відключити його можна будь-коли на сторінці «Мій Claude».',
    allow: 'Дозволити',
    deny: 'Відхилити',
    working: 'Підключаємо…',
    gone: 'Цей запит минув або на нього вже відповіли. Поверніться в Claude і натисніть Connect ще раз.',
  },
}
